var canvas, canvas2, text, fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1000, cHeight = 1400,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine, sizeB1W = 676, sizeB1H = 676;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


let backImg = document.querySelector("#night_lamp");
let backgroundImage = new fabric.Image(backImg, {
  left: 0,   
  top: 0,
  scaleX: 1.363,
  scaleY: 1.363,
  selectable: false
});

let frameImg = document.querySelector("#stylish_heart");
let simpleImage = new fabric.Image(frameImg, {
  left: 0,   
  top: 0,
  scaleX: 1.363,
  scaleY: 1.363,
  selectable: false
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(backgroundImage);
window['canvas2'].add(simpleImage);
// simpleImage.sendToBack();
addModify(window['canvas2']);




//-------------- Heart Calendar --------------

var inputDate = '2023-10-15',
  calendarGroup;


const cellWidth = 40;
const cellHeight = 29;
const startX = 40;
const startY = 140;


// Function to generate the calendar
document.getElementById('calendar-date').addEventListener('input', () => {
    const inputDate = document.getElementById('calendar-date').value;
    window['canvas2'].remove(calendarGroup);
    drawCalendar(inputDate);
});

function drawCalendar(inputDate){
    if (!inputDate) {
        alert('Please select a date.');
        return;
    }

    const selectedDate = new Date(inputDate);
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const selectedDay = selectedDate.getDate();

    calendarGroup = new fabric.Group([], {
        left: 0,
        top: 0,
      fill:'rgba(0,0,0,0)',
        selectable: true
    });

    // Get the first and last days of the month
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const firstDayOfWeek = firstDay.getDay();
    const totalDays = lastDay.getDate();

  
    const monthYearTitle = new fabric.Text(
      `${selectedDate.getDate()} ${selectedDate.toLocaleString('default', { month: 'long' })}, ${year}`, {
        left: 175,
        top: 68,
        fontSize: 30,
        fontFamily: 'Josefin Sans',
        fontWeight: 'bold',
        textAlign: 'center',
        originX: 'center',
        fill: '#fff'
      }
    );
  
    calendarGroup.addWithUpdate(monthYearTitle);
    calendarGroup.left = 495;
    calendarGroup.top = 1155;
    window['canvas2'].add(calendarGroup);
    calendarGroup.bringToFront();
};

drawCalendar(inputDate);


window['placeholderimg1'] = new fabric.Rect({
  left: 495,
  top: 535,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0)'
});

window['canvas2'].add(window['placeholderimg1']);
window['canvas2'].renderAll();


var heartimg,heartBorder,imgRatio,clipRatio,clipWidth = 676;
    heartPathString = "M370 125c0 66.3-53.7 120-120 120s-120-53.7-120-120S183.7 5 250 5s120 53.7 120 120Z";
var heartClip = new fabric.Path(heartPathString, {
  left: 495,
  top: 535,
  originX: 'center',
  originY: 'center',
  flipY: true,
  fill: 'transparent',
  absolutePositioned: true
});
heartClip.scaleToWidth(clipWidth);

canvas2.add(heartClip);

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg1'];
  available_height = img.height;
  sizeCrop = '1';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target,'#image1');
});


// Load the image and apply the clipPath
fabric.Image.fromURL('https://cdn.shopify.com/s/files/1/0796/4452/4821/files/Customizer-New.png?v=1755613546', function(heartimg){
  heartimg.set({ crossOrigin: 'anonymous' });
  heartimg.set({
    left: 495,
    top: 535,
    originX: 'center',
    originY: 'center',
    selectable: false,
    clipPath: heartClip
  });

  canvas2.add(heartimg);

  heartBorder = new fabric.Path(heartPathString, {
    left: 495,
    top: 535,
    originX: 'left',
    originY: 'top',
    fill: 'transparent',
    flipY: true,
    stroke: 'red',
    strokeWidth: 0,
    selectable: false
  });
  heartBorder.scaleToWidth(clipWidth);
  // canvas2.add(heartBorder);
  canvas2.renderAll();
}, { crossOrigin: 'anonymous' });


window['text1Page'] = new fabric.Text('click',{
  left: 490,
  top: 945,
  fontSize: 60,
  fontFamily: 'Miguella Charlotte',
  fill: '#fff',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');


window['canvas2'].add(window['text1Page']);

document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Javeria & Hassan') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 60;
  textObj.set({ fontSize });

  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 550);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});


var maxWidth = 550;
var maxHeight = 150;

var para = "The best thing to hold onto\nin life is each other." ;

window['text2Page'] = new fabric.Text(para,{
  left: 490,
  top: 1060,
  width: 550,
  fontSize: 40,
  fontWeight: 'bold',
  fontFamily: 'Josefin Sans',
  textAlign: 'center',
  isWrapping: true,
  fill: 'white'
});


window['canvas2'].add(window['text2Page']);

var minFontSize = 16;
var maxFontSize = 40;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'The best thing to hold onto\nin life is each other.') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});



// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  //fitTextToWidth(window['text2Page'], maxWidth);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight)
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}



// window['text3Page'] = new fabric.Text('@tasweer.com.pk',{
//   left: 672,
//   top: 790,
//   fontSize: 12,
//   fontFamily: 'Baloo 2',
//   fill: '#fff',
//   lockMovementX: true,
//   lockMovementY: true,
//   hasControls: false
// });


// window['canvas2'].add(window['text3Page']);


function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input,bImg){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
      jQuery(bImg).val(e.target.result);
      // simpleImage.bringToFront();
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  canvas.remove(heartimg).renderAll();
  fabric.Image.fromURL(imgurl, function(heartimg) {
    heartimg.set({ crossOrigin: 'anonymous' });
    heartimg.set({
      left: 495,
      top: 535,
      originX: 'center',
      originY: 'center'
    });
    heartimg.scaleToHeight(available_height);
    heartimg.clipPath = heartClip;
    canvas2.add(heartimg);
    console.log(heartimg);
    canvas2.renderAll();
  }, { crossOrigin: 'anonymous' });
  
}



function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});


document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas');
  fontSize = '';
  activeCOLOR = '';
  fontFamily = jQuery(this).val();
  canvas = window[fontID];
  updateFont(window['text1Page'],fontFamily,fontSize,activeCOLOR);
  fitTextToWidth(window['text1Page'], 550);
  window['text1Page'].bringToFront();
});




function updateFont(activeOb,family,size,fill){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    if(size == ''){
      size = activeOb.fontSize;
    }
    if(fill == ''){
      fill = activeOb.fill;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',size);
    activeOb.set('fontFamily',family);
    window['text1Page'].bringToFront();
    activeOb.set('fill',fill);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});

jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Javeria & Hassan');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=lamaPao; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];

  temp_images.push(jQuery('#crop_button').attr('data-cropped'));
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties[User Upload '+int+']">');
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,selectDate,entername,enterquote,chooseFont,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(backgroundImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    selectDate = jQuery('.calendar-date input').val();
    entername = jQuery('.enter_name input').val();
    enterquote = jQuery('.enter_quote textarea').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#entername').val(entername);
      jQuery('#selectDate').val(selectDate);
      jQuery('#enterquote').val(enterquote);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(backgroundImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}